export default __webpack_public_path__ + "static/media/copy.b1214952.svg";